module.exports = __webpack_public_path__ + "static/media/BGModal.0a8f90e9.webp";